import makeStyles from '@mui/styles/makeStyles';

const useInvoiceBillDownloadStyles = makeStyles({
  root: {}
});

export default useInvoiceBillDownloadStyles;
